import * as config from "Config";
import * as constants from "./constants";


export function clearStore() {
  return {
    type: constants.TAG_CLEAR_STORE
  };
}

export function saveNewTag(params) {
  let url = config.apiUrl + "/api/Tag";
  if (params.companyId) {
    url += "/Company/" + params.companyId;
  }
  if (params.companyGroupId) {
    url += "/CompanyGroup/" + params.companyGroupId;
  }
  return {
    remote: {
      method: "post",
      url,
      data: params
    },
    actions: [
      constants.TAG_NEW_SAVE_START,
      constants.TAG_NEW_SAVE_SUCCESS,
      constants.TAG_NEW_SAVE_FAIL,
    ]
  };
}


export function saveTag(params) {
  let url = config.apiUrl + "/api/Tag/" + params.id;
  if (params.companyId) {
    url += "/Company/" + params.companyId;
  }
  if (params.companyGroupId) {
    url += "/CompanyGroup/" + params.companyGroupId;
  }
  return {
    remote: {
      method: "put",
      url,
      data: params
    },
    actions: [
      constants.TAG_SAVE_START,
      constants.TAG_SAVE_SUCCESS,
      constants.TAG_SAVE_FAIL,
    ]
  };
}

export function getDetailTag(params) {
  let url = config.apiUrl + "/api/Tag/" + params.id;
  if (params.companyId) {
    url += "/Company/" + params.companyId;
  }
  if (params.companyGroupId) {
    url += "/CompanyGroup/" + params.companyGroupId;
  }

  return {
    remote: {
      method: "get",
      url
    },
    actions: [
      constants.TAG_DETAIL_START,
      constants.TAG_DETAIL_SUCCESS,
      constants.TAG_DETAIL_FAIL,
    ]
  };
}
